interface ChevronLeftIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
}

const ChevronLeftIcon = ({
  width = "24",
  height = "24",
  color = "currentColor",
}: ChevronLeftIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M15 18L9 12L15 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronLeftIcon;
